import React, {useState, useEffect} from 'react'
import {
	  StyledContainer,
	  StyledItem,
	  StyledImage
	} from '../../../components/Search/SearchResult/StyledSearchResult'
import Icons from '../../../components/Icons'
import styled from 'styled-components'
import {fetchManagerEmployees} from '../../../api/employees'
import {fetchBuildings} from '../../../utils/buildings'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import {useViewFetch} from '../../../utils/fetch'
import Avatar from '../../../components/Avatar/Avatar'
import {useUIDispatch, useUIState} from '../../../context/UIContext'

const Department = ({
  requestSpaceChange,
  requestEmployeeLeave,
  employee,
  onAddEmployee,
  onMoveDepartment,
  availableActions
}) => {
  const [filteredEmployees, setFilteredEmployees] = useState([])
  const [buttonDisplay, setButtonDisplay] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const localeState = useLocaleState()
  const uiDispatch = useUIDispatch()
  const uiState = useUIState()

  const [selectedSearchItem, setSelectedSearchItem] = useState({
  item: null,
  type: null
  })
  //const emId = employee.emId
  const {data: buildings} = useViewFetch({
    api: fetchBuildings
  })

  useEffect(
    () => {
      let isMounted = true

      if (isMounted) {
        setFilteredEmployees(buildings)
      }

      return () => {
        isMounted = false
      }
    },
    [buildings]
  )
  
  useEffect(
    () => {
      const {type, item} = selectedSearchItem

      if (type) {
        uiDispatch({
          type: 'showSearch',
          payload: {show: true, type, options: item}
        })
      }
    },
    [selectedSearchItem, uiDispatch]
  )
  
  const filter = e => {
    e.preventDefault()
    let value = e.target.value

    let filteredEmployees = buildings

    if (value) {
      filteredEmployees = buildings.filter(building =>
        building.name.toUpperCase().includes(value.toUpperCase()) || building.nameAbrev.toUpperCase().includes(value.toUpperCase()) ||
        building.blId.toUpperCase().includes(value.toUpperCase()) || building.address1.toUpperCase().includes(value.toUpperCase())
      )
    }

    setSearchValue(value)
    setFilteredEmployees(filteredEmployees)
  }

  const showButtons = () => {
    setButtonDisplay(!buttonDisplay)
  }
  
  const onItemSelect = ({type, item, evt}) => {
	    if (evt) {
	      evt.stopPropagation()
	    }

	    // Close the search panel
	    //setSearchValue('')
	    //setShowResult(false)
	    if(evt.key == "Enter" || evt.key == " " || !evt.key){
			if (type == "bl" && buildings.find(function a(blObj) {return blObj.blId == item.blId;}).adaFloors == 0)
			{
				if (confirm("Information about the building you selected is not currently available on this site.\n\nSelect 'OK' to open a new tab and view building data from the old web site.\n"))
				{
					window.open("http://ada.fs.illinois.edu/"+item.blId+".html")
				}
			}
			else
			{
				setSelectedSearchItem({type, item})
			}
	    }
	    
	  }

  let results = filteredEmployees.length + " Results"
  
  return (
    <Container>
      <ContainerLabel>{_L({key: 'Building List', localeState})}</ContainerLabel>
      <StyledContent>
        <StyledSearch show={buttonDisplay}>
          <Icons icon="SEARCH-GREY" />
          <StyledSearchInput
            id="bl-search-input"
            aria-label="Search by Building Name or Property Code"
            type={'search'}
            placeholder={_L({key: 'Search by Building Name or Property Code', localeState})}
            onChange={filter}
            value={searchValue}
          />
        </StyledSearch>
        <ResultCount role="status">
        	{results}
        </ResultCount>
      </StyledContent>
      <ListContainer>
          {filteredEmployees.map(bl => {
            let blId = bl.blId
            let blAbbr = bl.nameAbrev

            let blName = bl.name 
            if (blAbbr != ''){
            	blName = blName + ' (' + blAbbr + ')'
            }
			blName = blName + ' [' + blId + ']'
            let altBlName = 'Image of ' + bl.name

            return (
              <StyledBlContainer key={blId}>
	              <LinkWrapper
	              key={blId}
	              role="button"
	              tabIndex="0"
	              onKeyDown={evt => onItemSelect({item: {blId}, type: 'bl', evt})} 
	              onClick={evt => onItemSelect({item: {blId}, type: 'bl', evt})} 
	            >
	              <StyledImage>
	            	<Avatar alt={altBlName} url={bl.url} large type="building" />
	              </StyledImage>
	                <StyledItem color="black">
	                  {blName}
	                </StyledItem>
	                <StyledItemAddress color="#52555B">
	                  {bl.address1}
	                </StyledItemAddress>
	                <StyledItemCity color="#52555B" >
	                  {bl.cityId} {bl.cityStateId}
	                </StyledItemCity>
	    	        </LinkWrapper>
              </StyledBlContainer>

            )
          })}
      </ListContainer>
    </Container>
  )
}

export default Department

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`

const ListContainer = styled.ul`
  background-color: white;
  padding: 4px 3px 10px 20px;
  box-sizing: border-box;
  border-radius: 0 0 5px 5px;
  height: 100%;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  margin-top: -5px;
  margin-bottom: 20px;
  
`

const Button = styled.div`
  display: block;
  padding: 17px 24px 18px 24px;
  border: 1px solid #f3f5fb;
  border-radius: 5px;
  color: #000000;
  margin: 10px;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
`

const ContainerLabel = styled.h2`
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  color: #3E4044;
  margin-bottom: 10px;
  padding-top: 0px;
`

const StyledIcon = styled.span`
  font-size: large;
  font-weight: bold;
  color: #79b4f3;
  margin-right: 20px;
`

const StyledContent = styled.div`
  background: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
`

const StyledLabel = styled.div`
  font-size: 14px;
  color: #3E4044;
  padding: 14px;
`

const StyledSearch = styled.div`
  width: 325px;
  margin: 20px 0px 20px 20px;
  background: #f3f5fb;
  border-radius: 5px;
  padding: 8px;
  font-size: 14px;
  display: ${props => (props.show ? 'none' : 'inline-flex')};
  align-items: center;
  
  :focus-within {
	   border: 3px solid #FF9900;
	   
	}
	
  @media (max-width: 420px) {
    width: calc(100vw - 80px);
  }
`
const ResultCount = styled.div`
	margin: 0px 20px 0px 20px;
	font-size: 14px;
	display: inline-block;

`

const StyledSearchInput = styled.input`
  background: #f3f5fb;
  border: 0;
  padding-left: 14px;
  color: #3E4044;
  font-weight: normal;
  height: 20px;
  width: 100%;
  
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #3E4044;
  }
  :-ms-input-placeholder {
    color: #3E4044;
  }
  ::-ms-input-placeholder {
    color: #3E4044;
  }
  

`

const EditIconContainer = styled.div`
  display: flex;
  position: absolute;
  top: 5px;
  right: 12px;
  border-radius: 31px;
  width: 62px;
  height: 62px;
  cursor: pointer;
  box-shadow: 0 5px 9px 0 rgba(99, 129, 157, 0.33);
  justify-content: center;
  align-items: center;
`

const CancelIcon = styled(EditIconContainer)`
  background-color: #ffffff;
  text-align: center;
  font-weight: bold;
  color: gray;
`

const EditIcon = styled(EditIconContainer)`
  background-color: #3395fe;
`

const EditContainer = styled.div`
  padding: 0.5em;
  display: ${props => (props.show ? 'block' : 'none')};
`

const StyledBlContainer = styled.li`
list-style-type: none;

margin-bottom: 0;
border-bottom: 1px solid #f3f5fb;

@media (max-width: 768px) {
  padding: 12px 4px 12px 0px;
}

`

const LinkWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto 2fr 2fr 2fr 50px;
  grid-column-gap: 10px;
  grid-row-gap: 0;  
  text-decoration:none;
  cursor: pointer;
  padding: 12px 8px 12px 8px;
  
  &:hover {
  	background-color: #f3f9ff;
  }

  &:focus {
  	background-color: #f3f9ff;
  	outline: 3px solid #FF9900;
  }
  
  @media (max-width: 768px) {
	grid-template-rows: 25px 1fr 1fr;
	grid-template-columns: 50px 1fr 1fr;
	padding: 0 8px 0 8px;
  }
  
  @media (max-width: 420px) {
	grid-template-rows: auto auto auto;
	grid-template-columns: 50px 1fr;
	padding: 0 8px 0 8px;
  }
`
const StyledItemAddress = styled(StyledItem)`

@media (max-width: 420px) {
	grid-column: 2;
}
`

const StyledItemCity = styled(StyledItem)`

  grid-column: 4;

  @media (max-width: 768px) {
 	grid-column: 3;
  }
  
  @media (max-width: 420px) {
 	grid-column: 2;
  }
`